import { z } from 'zod';
export const PaymentTypeSchema = z.enum(['cash', 'check']);
export const DateFieldSchema = z.enum(['issue_date', 'due_date']);
export const ReceiptSchema = z.object({
    /** Stable per-row id within Arbox's receipts namespace.
     *  cash:  `<receipt_type>_<receipt_number>`            (one row per receipt)
     *  check: `<receipt_type>_<receipt_number>_<check_number>`
     *  Checks need check-level granularity because Arbox returns one row per
     *  check sharing (receipt_type, receipt_number) — users deposit them one
     *  at a time. */
    external_receipt_id: z.string(),
    /** Human-readable receipt number; rendered verbatim on the deposit slip. */
    receipt_number: z.string(),
    /** Optional URL to open the receipt document in a new tab. */
    receipt_url: z.string().url().nullable(),
    customer_external_id: z.string().nullable(),
    customer_name: z.string(),
    customer_url: z.string().url().nullable(),
    payment_type: PaymentTypeSchema,
    /** ILS major units. Non-ILS receipts are filtered out at the source.
     *  For a receipt a petty cash load took in part, this is what's LEFT. */
    amount: z.number(),
    /** The receipt's full amount — set only when a petty cash load took part
     *  of it (then `amount` is the remainder). */
    original_amount: z.number().optional(),
    /** 'YYYY-MM-DD' interpreted in Asia/Jerusalem. */
    issue_date: z.string(),
    /** Required for checks (post-dated common in IL); null for cash. */
    due_date: z.string().nullable(),
    check_number: z.string().nullable(),
    bank_code: z.string().nullable(),
    branch_number: z.string().nullable(),
    account_number: z.string().nullable(),
    /** Arbox project id; 0 (NO_PROJECT_ID) when Arbox returns null. */
    project_id: z.number(),
});
export const ListReceiptsQuerySchema = z.object({
    dateField: DateFieldSchema,
    /** 'YYYY-MM-DD' boundaries, Asia/Jerusalem. */
    from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    /** Optional location filter; required once Arbox response is confirmed to include location_id. */
    location_id: z.coerce.number().optional(),
    /** Project scope; ignored unless the box manages projects (then defaults to 0). */
    project_id: z.coerce.number().optional(),
});
//# sourceMappingURL=receipts.js.map